import { ConsumerPrice, ResellerPrice } from 'ui/components';
import { getValueTag } from 'ui/containers/ContentBuilder/widgets/utilities/tag';

import { TRACKING_CURRENCY } from '../../const';
import { getItemBadges } from '../../helpers';

import type { RootState } from 'core/store';

export const productDetail = (action: any, prevState: RootState) => {
  if (!action?.payload) {
    return;
  }
  return {
    event: 'view_item',
    ecommerce: {
      currency: TRACKING_CURRENCY,
      items: [
        {
          item_id: action?.payload?.sku,
          item_name: action?.payload?.name,
          affiliation: action?.payload?.tags.length ? 'promocao' : 'padrao',
          discount: getValueTag(
            action?.payload?.priceWrapper?.resellerPrice as unknown as ResellerPrice,
            action?.payload?.priceWrapper?.consumerPrice as unknown as ConsumerPrice,
            true,
          ),
          index: 0,
          item_brand: action?.payload?.skuOrganization,
          item_category: action?.payload?.departments[0]?.name,
          price: action?.payload?.priceWrapper?.resellerPrice.price,
          cd_item_tag: getItemBadges(action?.payload?.tags, prevState),
        },
      ],
    },
  };
};
